import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordCard = () => {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next.length < 8) return setError("Password baru minimal 8 karakter");
    if (form.next !== form.confirm) return setError("Konfirmasi password tidak sama");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password berhasil diganti");
      setForm(EMPTY);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  const fields = [
    ["current", "Password Lama", "current-password"],
    ["next", "Password Baru", "new-password"],
    ["confirm", "Ulangi Password Baru", "new-password"],
  ];

  return (
    <form onSubmit={submit} className="space-y-5 rounded-2xl border border-slate-200 bg-white p-6" data-testid="change-password-form">
      <div className="flex items-center gap-2">
        <KeyRound className="h-4 w-4 text-emerald-700" />
        <h3 className="font-display text-lg font-semibold text-slate-800">Ganti Password</h3>
      </div>
      {fields.map(([k, label, ac]) => (
        <div key={k} className="space-y-1.5">
          <Label htmlFor={`pw-${k}`}>{label}</Label>
          <Input id={`pw-${k}`} type="password" required autoComplete={ac} value={form[k]} onChange={set(k)} data-testid={`change-password-${k}-input`} />
        </div>
      ))}
      {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600" data-testid="change-password-error">{error}</p>}
      <Button type="submit" disabled={saving} className="bg-slate-900 hover:bg-slate-800" data-testid="change-password-submit-button">
        {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Ganti Password
      </Button>
    </form>
  );
};
